export default 'https://tme.understood.org/assets/Light_Texture02.a478c5e8.jpg'